import query from 'query-string';
import _ from 'lodash';

export const propExistsAndNonEmpty = prop => {
    if (typeof prop === 'undefined') {
        return false;
    }
    return Object.keys(prop).length > 0;
};

export const getVersionId = queryString => {
    const queryValues = getQueryParameters(queryString);
    const versionId = queryValues.v || 1;

    return versionId;
};

export const getQueryParameters = queryString => {
    const queryValues = query.parse(queryString);
    return queryValues;
};

export const serializeQueryParameters = parsedQuery => {
    return query.stringify(parsedQuery, {sort: false});
};

export const getCookieValue = cookieName => {
    const cookieDict = getAllCookies();
    return cookieDict[cookieName];
};

export const getAllCookies = () => {
    const cookies = document.cookie.split(';');

    // convert cookies to dictionary
    const cookieDict = {};
    cookies.map(cookie => {
        cookie = cookie.trim();
        const key = cookie.split('=')[0];
        const value = cookie.substring(cookie.indexOf('=') + 1);

        cookieDict[key] = value;
    });

    return cookieDict;
};

export const createFilterObject = (filter, promptId, position, context = null) => {
    const filterObject = {
        promptId,
        filterVal: filter,
        position
    };

    if (context) {
        filterObject.context = context;
    }

    return filterObject;
};

export const deleteFromArray = (array, value) => {
    if (array.indexOf(value) > -1) {
        array.splice(array.indexOf(value), 1);
    }
    return array;
};

export const includeFixedDigits = (string, fractionDigits = 1) => {
    return parseFloat(string).toFixed(fractionDigits);
};

export const convertStrToFloat = (string, fractionDigits = 1) => {
    const fixed = includeFixedDigits(string, fractionDigits);
    return +fixed; // convert to number
};

export const capitalize = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const shuffleArray = (array, seed = Math.random()) => {
    array = _.cloneDeep(array);

    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(seed * (i + 1));

        const temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }

    return array;
};

export const getParentPageDomain = () => {
    return document.location.ancestorOrigins[0];
};

export const getPathParam = (level = 1) => {
    // EX: /assessment/assessment/health-segments/results
    const {pathname} = window.location;

    const pathParts = pathname.split('/');

    // Discard the empty string from the leading slash and the common "assessment"
    const route = pathParts.slice(2);

    let index = level - 1;

    if (index >= route.length) {
        index = route.length - 1;
    } else if (!route[index]) {
        index = 0;
    }

    return route[index];
};
